module.exports = __webpack_public_path__ + "static/media/kit_keyboardPiano.6c5da52f.png";